import { Component, OnInit } from '@angular/core';
import {
  AggregatedWholeSaleDataDto,
  AggregatedWholeSaleDto,
  SettlementService
} from '@app/api/dmc';
import { TableConfig } from '@shared/interfaces/table/table-config';
import { TabsComponent } from '@shared/components/tabs/tabs.component';
import { TabComponent } from '@shared/components/tabs/tab/tab.component';
import { TableComponent } from '@shared/components/table/table.component';
import { ValueDetailsComponent } from '@shared/components/value-details/value-details.component';
import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import {
  settlementWholesaleMasterdata
} from '@shared/modals/settlement/settlement-wholesale-view-modal/settlement-wholesale.masterdata';
import { quantityQualityPartial } from '@shared/partials/quantity-quality.partial';

@Component({
  selector: 'app-settlement-wholesale-view-modal',
  imports: [
    TabsComponent,
    TabComponent,
    TableComponent,
    ValueDetailsComponent
  ],
  templateUrl: './settlement-wholesale-view-modal.component.html',
  styleUrl: './settlement-wholesale-view-modal.component.css'
})
export class SettlementWholesaleViewModalComponent implements OnInit {
  /** Params **/
  public id?: string;

  /** Element **/
  public wholeSaleElement?: AggregatedWholeSaleDto;

  /** Table **/
  public tableConfig: TableConfig<AggregatedWholeSaleDataDto> = {
    columns: [
      {
        title: 'settlement.metered.view.day',
        key: 'createdTS',
        cellRenderer: DateCellComponent,
      },
      {
        title: 'settlement.wholesale.view.energyprice',
        key: 'energyPrice',
      },
      {
        title: 'settlement.wholesale.view.energysum',
        key: 'energySum',
      },
      {
        title: 'settlement.metered.view.quantity',
        key: 'quantity',
      },
      quantityQualityPartial
    ]
  }

  public tableData: AggregatedWholeSaleDataDto[] = [];

  public wholesaleMasterdata: Columns<AggregatedWholeSaleDto>[] = settlementWholesaleMasterdata;

  constructor(
    private readonly settlementService: SettlementService,
  ) {

  }

  public ngOnInit(): void {
    if (this.id) {
      this.settlementService.settlementGetAggregatedWholesaleGet(this.id).subscribe(
        (result: AggregatedWholeSaleDto) => {
          this.wholeSaleElement = result;
          this.tableData = result.timeSeries ?? [];
        }
      )
    }
  }

}
